module.exports = __webpack_public_path__ + "static/cgi-min-cd65943ef9b8a7bf95d228d7a7c23a3e.jpg";